<template>
    <div class="message-text">
        <span style="font-size: 1rem!important">{{value}}</span>
    </div>
</template>
<style scoped lang="scss">
    .message-text {
        position: relative;
        top: -10px;
        text-align: center;
        >span {
            font-size: 1rem!important;
            color: $primary
        }
    }
</style>
<script>
export default {
  name: 'ResultMessage',
  props: {
    value: String
  }
}
</script>



// WEBPACK FOOTER //
// src/front/components/pages/layout/common/ResultMessage.vue